import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ArrowDown from "../assets/images/down-arrow-fill.svg";
import ArrowDownInactive from "../assets/images/down-arrow-fill-inactive.svg";
import infoIcon from '../assets/images/info-icon.svg'

const TableSorting = ({tableHeaderSort, from, yieldDataFirst}) => {
  const [sortConfig, setSortConfig] = React.useState({ key: null, direction: null });
  const processedData = yieldDataFirst && yieldDataFirst.map((row) => {
      if (from === "PensionPage") {
        return {
          name: row.FUND_NAME,
          monthly: row.MONTHLY_YIELD || 0,
          monthly_sum: row.LAST_12_MONTH_YIELDS || 0,
          threeYears: row.YIELD_TRAILING_3_YRS || 0,
          fiveYears: row.YIELD_TRAILING_5_YRS || 0,
          depositmanagementfee: row.AVG_ANNUAL_MANAGEMENT_FEE || 0,
          propertymanagementfees: row.SHARPE_RATIO || 0,
          totalAssets: row.TOTAL_ASSETS || 0
        };
      }
      return row;
    });


  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    const isActive = sortConfig.key === key;
    const isAscending = sortConfig.direction === 'ascending';

    return (
      <span className="table-fillter">
        <img
          src={isActive && !isAscending ? ArrowDown : ArrowDownInactive}
          alt="Arrow Up"
          className="table-arrow-up"
          onClick={() => requestSort(key)} 
          style={{ cursor: 'pointer' }}
        />
        <img
          src={isActive && isAscending ? ArrowDown : ArrowDownInactive}
          alt="Arrow Down"
          className="table-arrow-down"
          onClick={() => requestSort(key)}
          style={{ cursor: 'pointer' }}
        />
      </span>
    );
  };

  const sortRows = (rows) => {
    if (!sortConfig.key) return rows;

    return [...rows].sort((a, b) => {
      const { key, direction } = sortConfig;
      const valueA = parseFloat(a[key]) || a[key];
      const valueB = parseFloat(b[key]) || b[key];

      if (valueA < valueB) return direction === 'ascending' ? -1 : 1;
      if (valueA > valueB) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
  };

  const formatPercentage = (value) => {
    if (typeof value === 'string' && value.includes('%')) {
      const numericValue = parseFloat(value.replace('%', '')); 
      return `${numericValue.toFixed(2)}%`; 
    }
    return value; 
  };

  return (
    <div className="table-sort-main sort-fillter">
      <div className="table-wrapper table-wrapper-2">
        <TableContainer component={Paper}>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
              {tableHeaderSort.map(({ key, label, tooltip }) => (
                  <TableCell key={key}>
                    {getSortIcon(key)} {label}
                    {tooltip && (
                      <span className="information-tooltip">
                        <img className='info_icon' src={infoIcon} alt='info' />
                        <small>{tooltip}</small>
                      </span>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortRows(processedData).map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell className="green-text">{formatPercentage(row.monthly)}%</TableCell>
                  <TableCell className="green-text">{formatPercentage(row.monthly_sum)}%</TableCell>
                  <TableCell className="green-text">{formatPercentage(row.threeYears)}%</TableCell>
                  <TableCell className="green-text">{formatPercentage(row.fiveYears)}%</TableCell>
                  <TableCell>{row.depositmanagementfee}</TableCell>
                  <TableCell>{row.propertymanagementfees}</TableCell>
                  <TableCell>{row.totalAssets}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default TableSorting;
